var plugin_rtlignore_default = {
  "alignLeft": "WWzGx",
  "textWrapNowrap": "wDkRU",
  "alignRight": "fRjWL",
  "alignCenter": "a4NL0",
  "sizeFullWidth": "XcYbZ",
  "renderedInTable": "_758BZ",
  "sizeOriginal": "qXm2n",
  "sizeContent": "_1ZpNn",
  "sizeSmall": "B88GD",
  "sizeSmallCenter": "_-3sKj",
  "flex": "_1CMI0",
  "atomic": "_24-n5",
  "embed": "HAppf",
  "horizontalScrollbar": "ZwsCJ",
  "pluginContainerMobile": "_3CPj8"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
